import StateTransitionAction from '@/ecm/models/workflow/StateTransitionAction';
import Utils from '@/ecm/common/Utils';
export default class StateTransition {
    constructor (dto) {
        this.uuid = Utils.object.getUUID();
        this.id = 0;
        this.stateTo = 0;
        this.transitionType = 'V';
        this.digitalSignatureConfigId = '';
        this.conditionStr = '';
        this.displayConditionStr = '';
        this.roleTypeIDs = [];
        this.actions = [];
        this.totalRequiredValidations = 1;
        this.convertTo = 0;

        if (dto) {
            this.id = dto.Id;
            this.stateTo = dto.StateTo;
            this.transitionType = dto.TransitionType;
            this.digitalSignatureConfigId = dto.DigitalSignatureConfigID + '';
            this.conditionStr = dto.ConditionStr;
            this.displayConditionStr = dto.DisplayConditionStr;
            this.roleTypeIDs = dto.RoleTypeIDs.map(x => x + '');
            this.totalRequiredValidations = dto.TotalRequiredValidations;
            this.convertTo = dto.ConvertTo;
            this.actions = dto.Actions.map(function (dto) { return new StateTransitionAction(dto); });
        }
    }

    toDto () {
        return {
            Id: this.id,
            StateTo: this.stateTo,
            TransitionType: this.transitionType,
            DigitalSignatureConfigID: this.digitalSignatureConfigId,
            ConditionStr: this.conditionStr,
            RoleTypeIDs: this.roleTypeIDs.map(x => parseInt(x)),
            Actions: this.actions.map(x => x.toDto()),
            ConvertTo: this.convertTo,
            TotalRequiredValidations: this.totalRequiredValidations
        };
    }
}
